<template>
  <div
    ref="container"
    class="infinite-vertical-scroll"
    :style="{ height: containerHeight + 'px' }"
    @mouseenter="pause"
    @mouseleave="resume"
    @wheel="onWheel"
  >
    <div
      ref="content"
      class="infinite-vertical-scroll-content"
      :style="{ transform: `translateY(${-scrollTop}px)` }"
    >
      <div ref="slotContent">
        <slot />
      </div>
      <div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import { watch, ref, onMounted, onBeforeUnmount, nextTick } from 'vue';

const props = defineProps({
  speed: { type: Number, default: 1 }, // px per frame
  direction: { type: String, default: 'up' }, // 'up' or 'down'
  datalength: { type: Number, default: 0 }, // 用于初始化动画
  height: { type: Number, default: 0 }, // 可选：外部指定高度
  debug: { type: Boolean, default: false } // 可选：外部指定高度

});

const container = ref(null);
const content = ref(null);
const slotContent = ref(null);
const scrollTop = ref(0);
let contentHeight = 0;
let frameId = null;
const paused = ref(false);
const containerHeight = ref(0);

function updateHeights() {
  // 计算 slot 内容高度
  if (slotContent.value) {
    contentHeight = slotContent.value.scrollHeight;
    // console.log('内容高度', contentHeight,props.datalength);
    // 自动设置容器高度
    containerHeight.value = props.height > 0 ? props.height : contentHeight;
  }
}

function loop() {
  if (!paused.value) {
    if (props.direction === 'up') {
      scrollTop.value += props.speed;
      // if(props.debug) console.log('scrollTop', scrollTop.value);
      if (scrollTop.value >= contentHeight) {
        scrollTop.value -= contentHeight;
      }
    } else {
      scrollTop.value -= props.speed;
      if (scrollTop.value < 0) {
        scrollTop.value += contentHeight;
      }
    }
  }
  frameId = requestAnimationFrame(loop);
}

function pause() {
  paused.value = true;
}
function resume() {
  paused.value = false;
}
function onWheel(e) {
  e.preventDefault();
  if (props.direction === 'up') {
    scrollTop.value += e.deltaY * 0.5;
    if (scrollTop.value >= contentHeight) {
      scrollTop.value -= contentHeight;
    } else if (scrollTop.value < 0) {
      scrollTop.value += contentHeight;
    }
  } else {
    scrollTop.value -= e.deltaY * 0.5;
    if (scrollTop.value >= contentHeight) {
      scrollTop.value -= contentHeight;
    } else if (scrollTop.value < 0) {
      scrollTop.value += contentHeight;
    }
  }
}

async function init() {
  await nextTick();
  updateHeights();
  scrollTop.value = 0;
}

watch(
  () => props.datalength,
  async () => {
    await init();
  }
);

onMounted(async () => {
  await init();
  window.addEventListener('resize', updateHeights);
  frameId = requestAnimationFrame(loop);
});

onBeforeUnmount(() => {
  cancelAnimationFrame(frameId);
  window.removeEventListener('resize', updateHeights);
});
</script>

<style scoped>
.infinite-vertical-scroll {
  width: 100%;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  user-select: none;
}
.infinite-vertical-scroll-content {
  display: flex;
  flex-direction: column;
  will-change: transform;
}
</style>